import { memo } from 'react';

import { useNekuodah } from './hooks/useNekuodah';
import { NekuodahProps } from './types/NekuodahProps';
import { Level } from './Level';

const NekuodahComponents = ({ components, children }: NekuodahProps) => {
  const { component, childComponent } = useNekuodah(components, children);

  if (!components.length) {
    return <>{children}</>;
  }

  return (
    <Level childComponent={childComponent} component={component}>
      {children}
    </Level>
  );
};

export const Nekuodah = memo(NekuodahComponents);
